import { workOrderListQuerySchema } from '@chukua/common';
import { useDirectoryList } from '../../../hooks/use-directory-list';
import { listWorkOrders } from '../work-orders.api';
import { useTruckRegistrations } from './use-truck-registrations';

/** The work order list: server-paged, with the registration of each truck on the page looked up beside it. */
export function useWorkOrders() {
  const { state, list, isRefreshing, reload } = useDirectoryList(workOrderListQuerySchema, listWorkOrders);
  const registrations = useTruckRegistrations(state.status === 'loaded' ? state.page.items.map((order) => order.truckId) : []);
  const isFiltered = list.isFiltered || list.query.scope !== undefined;
  return { state, list: { ...list, isFiltered }, isRefreshing, reload, registrations };
}
